import { ArrowDownRight, MessageCircle } from "lucide-react";
import { scrollToId } from "../../lib/scroll";
import { Reveal } from "./Reveal";

export const FinalCTA = () => (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-ink py-24 text-center text-[#f8f6f0] lg:py-32">
        <div
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-0 h-[30rem] w-[60rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(ellipse,rgba(45,212,191,0.14),transparent_65%)]"
        />
        <div className="relative mx-auto max-w-4xl px-5">
            <Reveal>
                <p className="font-display text-lg italic text-teal-300">Smile Dental Clinic · Kasba</p>
                <h2 className="mt-5 font-display text-4xl font-light leading-[1.08] sm:text-5xl lg:text-6xl">
                    Take the First Step Toward a <em className="font-medium text-teal-300">Healthier Smile.</em>
                </h2>
                <p className="mx-auto mt-6 max-w-xl text-base text-slate-300 md:text-lg">
                    Book your dental consultation and take the next step toward better oral health.
                </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center justify-center gap-4">
                <button
                    data-testid="final-book-appointment-btn"
                    onClick={() => scrollToId("#appointment")}
                    className="group inline-flex items-center gap-2 rounded-full bg-teal-accent px-8 py-4 text-sm font-extrabold uppercase tracking-[0.12em] text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-teal-500"
                >
                    Book Appointment
                    <ArrowDownRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
                </button>
                <button
                    data-testid="final-whatsapp-btn"
                    className="inline-flex items-center gap-2 rounded-full border border-white/25 px-8 py-4 text-sm font-extrabold uppercase tracking-[0.12em] transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-teal-300 hover:bg-white/10"
                >
                    <MessageCircle className="h-4 w-4 text-teal-300" />
                    WhatsApp Clinic
                </button>
            </Reveal>
        </div>
    </section>
);
